import React from 'react'
import VoiceOrderTaker from '../../Component/VoiceOrderTaker/VoiceOrderTaker'
import BurgerMenuTitle from '../../Component/BurgerMenuTitle/BurgerMenuTitle'
import Style from './VoiceOrder.module.css'
const VoiceOrder = () => {
  return (
    <div className={Style.pageHolder}>
      <BurgerMenuTitle title={"سفارش هوشمند صوتی"} />
      <VoiceOrderTaker/>
      </div>
  )
}

export default VoiceOrder